import Vue from 'vue';
import store from 'store';
import { isTablet } from 'utils/general';
import on from 'dom-event';
import debounce from 'lodash.debounce';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';

export default (el) =>
  new Vue({
    el,
    store,
    components: {
      'lookbook-modal': () => import('../lookbook-modal/lookbook-modal.vue'),
    },
    name: 'Shoppable lookbook with See More',
    data() {
      return {
        isTablet: isTablet(),
        showModal: false,
        isModalActive: false,
        look: null,
      };
    },
    mounted() {
      on(window, 'resize', debounce(this.onResize, 300));
      this.$on('close-modal', this.closeModal());
      this.setupVideo();
    },
    methods: {
      onResize() {
        if (this.isTablet !== isTablet()) {
          this.closeModal();
        }
        this.isTablet = isTablet();
      },
      toggleMoreLooks(event) {
        const el = event.target.closest('.shoppable-lookbook__looks');
        el.classList.toggle('open');
      },
      setupVideo() {
        const el = this.$el.querySelector('[data-look-json]');
        const isVimeoScriptLoaded =
          document.querySelector(
            'script[src="https://player.vimeo.com/api/player.js"]',
          ) !== null;
        if (el) {
          const data = JSON.parse(el.getAttribute('data-look-json'));
          const hasVideo = data?.find((look) => !!look.video_link);
          if (hasVideo && !isVimeoScriptLoaded) {
            const script = document.createElement('script');
            // add attribute && class to prevent one trust auto-blocker
            // see https://my.onetrust.com/articles/en_US/Knowledge/UUID-71e7d0a8-03d8-e272-e683-72cadded2ecf
            script.setAttribute('data-ot-ignore', '');
            script.setAttribute('class', 'optanon-category-C0001');
            script.src = 'https://player.vimeo.com/api/player.js';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
          }
        }
      },
      openLookbookModal(index, event) {
        const el = event.target.closest('.shoppable-lookbook__look');
        const data = JSON.parse(el.getAttribute('data-look-json'));

        this.look = data?.[index];

        if (!this.look.content && !this.look.video_link && !this.look.products)
          return;

        this.showModal = true;
        setTimeout(() => {
          this.isModalActive = true;
          document.body.classList.add('scroll-lock');
        }, 800);
      },
      closeModal() {
        this.isModalActive = false;
        clearAllBodyScrollLocks();
        document.body.classList.remove('scroll-lock');
        setTimeout(() => {
          this.showModal = false;
        }, 300);
      },
    },
  });
